import ChartNivAcuteBuikpijn from "../../../../src/client/niv_acuteboekje/json/acute-buikpijn.json";
import ChartNivSchematic from "../../../../src/client/niv_acuteboekje/interactions/chart_schematic/ChartNivSchematic";
import * as React from 'react';
export default {
  ChartNivAcuteBuikpijn,
  ChartNivSchematic,
  React
};